import html3pdf from 'html3pdf';
import { currentDatetime, formatDateToWords,} from '../../helpers';
import { ToastContainer } from 'react-toastify';

import logo from "../../assets/images/logo-2.png"

const PdfGenerateCertificate = (props) => {
  const { data, role, issuerInformation } = props
  const generatePdf = () => {
    const pdfContent = document.getElementById('pdf-content');

    html3pdf(pdfContent, {
      margin: 10,
      filename: `${data.referenceNumber}-Certificate-of-Delivery-${currentDatetime.substring(0, 10)}.pdf`,
      image: { type: 'jpeg', quality: 0.98 },
      html3canvas: { scale: 2 },
      jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
    });
  };

  return (
    <div style={{padding: "12px 0", minHeight: "calc(100vh - 160px)"}}>
      {/* Button to generate PDF */}
      <div style={{display: "flex",justifyContent: "end"}}>
        <div className='actions blue' style={{width: "fit-content"}} onClick={generatePdf}>
          <span className="material-symbols-rounded">download</span>
          <span>Download PDF</span>
        </div>
      </div>
      <hr style={{border: "1px solid #e9e9e9", marginTop: "12px"}} />

      {/*  div with content for PDF generation */}
      <div id="pdf-content" className='pdf-content' >
        <div style={{height: "300px", border: "1.5px solid orange", padding: "32px 0"}}>
          <div style={{display: "flex", justifyContent: "center"}}>
            <img src={logo} alt="logo" width="40px" />
          </div>
          <h2 className='text-center' style={{fontSize: "24px", color: "#175EBF", margin: "28px 0"}}>CERTIFICATE OF {role ? role === "FreightForwarder" ? "SHIPMENT" : "DELIVERY": ""}</h2>
          <div style={{fontSize: "12px", textAlign: "center", color: "#3e3e3e"}}>AWARDED TO</div>
          <div style={{padding: "0 40px", marginBottom: "32px"}}>
            <h3 
              style={{fontFamily: "serif", fontSize: "22px", color: "orange", marginTop: "8px", textAlign: "center", borderBottom: "1.5px solid orange", padding: "16px"}}
              >{data?.companyName}</h3>
          </div>
          <div style={{fontSize: "12px", textAlign: "center"}}>For the { role === "FreightForwarder" ? "" : "delivery of "}shipment with BL/AWL Number <strong>{data?.referenceNumber}</strong> on <strong>{formatDateToWords(data?.date)}</strong>.</div>
        
          <p className='text-center' style={{marginTop: "40px"}}>Issued by <strong style={{color: "#175EBF"}}>{issuerInformation?.approver?.firstName} {issuerInformation?.approver?.lastName} on {formatDateToWords(issuerInformation?.approvalDate)}</strong></p>
        </div>        
        <ToastContainer />
      </div>
    </div>
  );
};

export default PdfGenerateCertificate;
